import { useSelector } from 'react-redux';
import { BotIcon } from '../FlowComponents/BotIcon';
export default function Typing() {
  const design = useSelector((state: any) => state?.design);
  return (
    <div id='ele-278' className="main-container fade-in">
      <div id='ele-279' className={`message items-end  ${design.avatarPlacement !== 'top' ? 'flex' : ''}`}>
        <BotIcon type='bot'></BotIcon>
        <div id='ele-280' className={`rounded-xl py-3 px-5 max-w-80 bg-primaryBgColor relative rounded-bl-none mt-3 min-w-20 ${design.avatarPlacement === 'top' ? 'inline-block' : ''}`}>
          <img className="h-5" src={process.env.REACT_APP_CDN + "/typing.gif"} alt="loading..." />
        </div>
      </div>
    </div>

  )
}
